<template>
    <div>
        <Modal v-model="visible" :title="formData.id ? '维持编辑' : '维持新增'" width="560" class="my-modal top"
            :mask-closable="false" :footer-hide="true">
            <Form v-if="showPupUp" ref="form" :model="formData" class="full form" :label-width="80">
                <FormItem prop="currentLevelId" label="维持职级" class="full">
                    <Select clearable v-model="formData.oldRankId" transfer filterable>
                        <Option v-for="item in baseRankList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="commissionSelected" label="维持条件" :rules="$units.formRule.required('请选择')" class="full">
                    <Select transfer v-model="formData.commissionSelected" not-found-text="暂无条件，请联系您的商务经理">
                        <Option v-for="item in condition" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <FormItem prop="condition" label="维持要求" class="full">
                    <span class="text">{{ condition.find(i => i.id == formData.commissionSelected) && condition.find(i =>
                        i.id
                        == formData.commissionSelected).ruleName }}</span>
                </FormItem>
            </Form>

            <div class="ivu-modal-footer">
                <Button type="text" @click="visible = false">取消</Button>
                <Button type="primary" @click="save">确认</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import filter from '@/api/filter';
import selectTree from '@/components/system/selectTree3';
export default {
    props: ['initList'],
    components: { selectTree },
    data() {
        return {
            filter,
            visible: false,
            showPupUp: false,
            formData: {},
            condition: [],
            baseRankList: [],
        };
    },
    methods: {
        //获取职级
        getBaseRank() {
            this.$http({
                url: '/buz/baseRank/read/all',
                type: 'POST',
                data: {}
            }).then(res => {
                this.baseRankList = res.data;
            });
        },
        open(data) {
            this.visible = true;
            this.showPupUp = true;
            this.formData = data;
            this.getBaseRank()
            this.getCondition()
            this.$refs.form && this.$refs.form.resetFields();
        },

        getCondition() {
            this.$http({
                url: '/buz/promotionRule/condition/list',
                type: 'GET',
                data: {

                }
            }).then(res => {
                let data = res.data.find(i => i.type == 2)
                if (data.condition.some(i => i.ruleName)) {
                    this.condition = data.condition;
                }
            });
        },
        save() {
            this.$refs.form.validate().then(isok => {
                if (!isok) {
                    return;
                }
                let data = {
                    ...this.formData,
                    type: 2
                };
                console.log(data);
                this.$http({
                    url: this.formData.id ? '/buz/promotionRule/update' : '/buz/promotionRule/save',
                    type: 'POST',
                    data
                }).then(res => {
                    this.formData = {};
                    this.initList();
                    this.$notice.success('操作成功');
                    this.visible = false;
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.my-modal {
    .form {
        margin-top: 10px;
    }

    /deep/ {
        .ivu-modal-body {
            padding-top: 0;
        }
    }

    .text {
        display: block;
        font-size: 13px;
        margin-top: 2px;
    }
}
</style>
